import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TRANSLOCO_SCOPE, TranslocoModule } from "@ngneat/transloco";
import { ForgotPasswordRequestComponent } from './forgot-password-request/forgot-password-request.component';
import { SharedModule } from '../../common/shared.module';


@NgModule({
  declarations: [
    LoginComponent,
    ForgotPasswordRequestComponent
  ],
  providers: [{provide: TRANSLOCO_SCOPE, useValue: {scope: 'login_register', alias: 'login_register'}}],
  imports: [
    CommonModule,
    LoginRoutingModule,
    SharedModule,
    FormsModule,
    TranslocoModule,
    ReactiveFormsModule
  ]
})
export class LoginModule { }
